import { FunctionComponent, useCallback } from "react";
import "./Header.scss";
import { useNavigate, useLocation } from "react-router-dom";
import images from "../../assets/images";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { logout } from "../../redux/slices/authSlice";
import { VIRTUAL } from "../../utils/constants";


const Header: FunctionComponent = () => {
  const navigate = useNavigate();
  const {katonHeaderLogo} = images;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isKaton, participantCode, schoolType } = useAppSelector((state) => state.auth);
    
  // navigate to landing page while click header logo
  const onHeaderLogoImageClick = useCallback(() => {
    const component = isKaton === "facilitator" ? "/facilitator-login?isKaton=facilitator" : isKaton === "participant" ? `/participant-login${location?.search ? location?.search : `?isKaton=participant&code=${participantCode}`}` : (isKaton === "virtualSchool" ? "/?isKaton=virtualSchool" : "/");
    navigate(component);
    dispatch(logout());
  }, [isKaton]);


  //navigate to school admin login page while click school admin label in header
  const onSchoolAdminClick = useCallback(() => {
    navigate('/admin-login');
    dispatch(logout());
  }, []);

  //navigate to teacher login page while click teacher label in header
  const onTeacherClick = useCallback(() => {
    // Add your navigation logic here
    navigate('/teacher-login');
    dispatch(logout());
  }, []);

  //navigate to pta page while click pta label in header
  const onPtaClick = useCallback(() => {
    // Add your navigation logic here
    navigate('/pta-verifyCode');
    dispatch(logout());
  }, []);

  return (
    <section className="sectionHeader">
      <div className="headercontainer">
        <img
          className={`hdrLogoIcon ${(location.pathname?.includes("/facilitator-login") || location.pathname?.includes("/participant-login"))? "disabled" : ""}`}
          alt="logoImage"
          src={katonHeaderLogo}
          onClick={onHeaderLogoImageClick}
          
        />
          <div className="menuParent">
            <div className="menu">
              <div className={`schoolAdmin ${location.pathname === "/admin-login" ? "active" : ""}`} onClick={onSchoolAdminClick}>
                School Admin
              </div>
              <div className={`teacher ${((location.pathname === "/teacher-login") || (location.pathname === '/teacher-select-class') )? "active" : ""}`} onClick={onTeacherClick}>
                Teacher
              </div>
              <div className={`pta ${location.pathname === "/pta-verifyCode" || location.pathname === "/pta-signup" || location.pathname === "/pta-login" ? "active" : ""}`}  onClick={onPtaClick}>PTA</div>
            </div>
            <button title="hamBurgerMenu" className="icMobileMenu">
              <img className="icMenu2" alt="hamburgerMenu" src="/ic--menu-2.svg" />
            </button>
          </div>
      </div>
    </section>
  );
};

export default Header;
